import { Fachbereich } from '../../mdqx-graphql-types';

export class FachbereichEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(fachbereichType?: Fachbereich | null) {
        if (fachbereichType && fachbereichType.id != null && fachbereichType.name != null) {
            this.Id = fachbereichType.id;
            this.Name = fachbereichType.name;
        } else {
            console.error('received broken FachbereichType', fachbereichType);
            throw Error();
        }
    }
}
